import { IPoint } from "./Point";
import { Site } from './Site';

export class BeachSite {
	public Identifier : string;
	public SiteName : string;
	public PollutionForecast : string;
	public LatestResultStarRating : number;
	public Council : string;
	//public Region : string;
	public ParentRegion : string;	
	public SubRegion : string;
	public PartnerGroup : string;
	public Lat : number;
	public Lng : number;
	public SiteType: string;

	constructor(
		identifier : string,
		siteName : string,
		pollutionForecast : string,
		latestResultStarRating : number,
		council : string,
		subRegion : string,
		parentRegion : string,
		partnerGroup : string,
		lat : number,
		lon : number,
		siteType: string) 
	{
		this.Identifier = identifier;
		this.SiteName = siteName;
		this.PollutionForecast = pollutionForecast;
		this.LatestResultStarRating = latestResultStarRating;
		this.Council = council;
		this.SubRegion = subRegion;
		this.ParentRegion = parentRegion;
		this.PartnerGroup = partnerGroup;
		this.Lat = lat;
		this.Lng = lon;
		this.SiteType = siteType;
	}	

	toString() {
		return this.SiteName ? this.SiteName : "";
	}
}


export function isBeachSite(object: any) : object is BeachSite {	
    return 'Identifier' in object && 
        'SiteName' in object &&
		'PollutionForecast' in object && 
        'LatestResultStarRating' in object &&
		'Council' in object && 
        'SiteName' in object &&
		'SubRegion' in object && 
		'ParentRegion' in object &&
        'PartnerGroup' in object &&
		'Lat' in object && 
        'Lng' in object;
}
